import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FiMenu, FiX, FiPlusCircle, FiZap, FiClock, FiCheckCircle, FiBookOpen, FiLink, FiList, FiBarChart2 } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import s from './Navbar.module.css';

const NAV_ITEMS = [
  { to: '/create', label: 'Create', icon: <FiPlusCircle /> },
  { to: '/clasico', label: 'Clasico', icon: <FiZap /> },
  { to: '/pending', label: 'Pending', icon: <FiClock /> },
  { to: '/results', label: 'Results', icon: <FiCheckCircle /> },
  { to: '/integrations', label: 'Integrations', icon: <FiLink /> },
  { to: '/manual-markets', label: 'Manual Markets', icon: <FiList /> },
  { to: '/analytics', label: 'Analytics', icon: <FiBarChart2 /> },
  { to: '/history', label: 'History', icon: <FiBookOpen /> },
];

export default function Navbar() {
  const { user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const filteredItems = NAV_ITEMS.filter(item => {
    if (!item.roles) return true;
    return item.roles.includes(user?.type);
  });

  return (
    <nav className={s.nav}>
      <div className={s.navInner}>
        <NavLink to="/" className={s.logo}>
          <img className={s.logoImg} src={process.env.PUBLIC_URL + '/clasico_analytics.jpeg'} alt="Logo" />
          <span className={s.logoText}>Clasico Analytics</span>
        </NavLink>

        <div className={s.navCenter}>
          <ul className={s.navLinks}>
            {filteredItems.map(item => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === '/'}
                  className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}
                >
                  {item.icon}
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
          {user?.type && <span className={s.roleTag}>{user.type}</span>}
        </div>

        <button className={s.hamburger} onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && <div className={s.mobileOverlay} onClick={() => setMenuOpen(false)} />}
      <div className={`${s.mobileMenu} ${!menuOpen ? s.mobileMenuHidden : ''}`}>
        {filteredItems.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) => `${s.mobileLink} ${isActive ? s.mobileLinkActive : ''}`}
            onClick={() => setMenuOpen(false)}
          >
            {item.icon}
            {item.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

